export const NO_SITE_FILTER_VALUE = '__no_site__';
